import { formatarMoeda } from '@/shared/utils/numeros';
import { extrairYyyyMm, formatarYyyyMmMesExtensoOuIndefinido } from '@/shared/utils/datas';
import { SimuladorFolhaPorMes } from '../simulador-folha.types';

interface Props {
  dados: SimuladorFolhaPorMes[];
  tableId?: string;
}

export function TabelaPorMes({ dados, tableId = 'tabela-simulador-mes' }: Props) {
  const totais = dados.reduce(
    (acc, item) => ({
      totalAtual: acc.totalAtual + item.totalAtual,
      totalProjetado: acc.totalProjetado + item.totalProjetado,
      diferenca: acc.diferenca + item.diferenca,
    }),
    { totalAtual: 0, totalProjetado: 0, diferenca: 0 },
  );

  return (
    <div className="table-responsive">
      <table id={tableId} className="table table-sm table-bordered table-striped">
        <thead>
          <tr>
            <th>Mês</th>
            <th className="text-center">Qtd.</th>
            <th className="text-end">Atual</th>
            <th className="text-end">Projetado</th>
            <th className="text-end">Diferença</th>
          </tr>
        </thead>
        <tbody>
          {dados.map((item) => (
            <tr key={item.competencia}>
              <td>{formatarYyyyMmMesExtensoOuIndefinido(extrairYyyyMm(item.competencia))}</td>
              <td className="text-center">{item.quantidadeServidores}</td>
              <td className="text-end">{formatarMoeda(item.totalAtual)}</td>
              <td className="text-end">{formatarMoeda(item.totalProjetado)}</td>
              <td className="text-end">{formatarMoeda(item.diferenca)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot className="table-secondary fw-semibold">
          <tr>
            <td>Total acumulado</td>
            <td />
            <td className="text-end">{formatarMoeda(totais.totalAtual)}</td>
            <td className="text-end">{formatarMoeda(totais.totalProjetado)}</td>
            <td className="text-end">{formatarMoeda(totais.diferenca)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
